import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions, Button}from "@material-ui/core";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../appConfigContext";

const styles = theme => ({
    dialog:{
        padding:"18px 24px",
        boxSizing: "border-box",
        borderRadius:"2px",
        backgroundColor: theme.ModalBGColor,
        boxShadow: "2px 2px 4px black",
        width:400,
        userSelect:'none'
    },
    dialogTitle:{
        fontSize:14,
        fontWeight:"600",
        lineHeight:"20px",
        color: theme.HeaderSelectedText,
        padding:0
    },
    dialogContent:{
        fontSize:theme.textFontSize,
        color: theme.TextColor,
        overflow:"hidden",
        padding:"16px 0px"
    },
    button:{
        fontSize:14,
        textTransform:"none",
        borderRadius:"2px",
        margin:0,
        width:"47%",
    },
    dialogAction:{
        justifyContent:"space-between",
        margin:0,
        '&$actionButton':{
            paddingBottom:0,
            paddingRight:0
        }
    },
    actionButton:{
        margin:0,
        padding:0,
        display:'flex',
        justifyContent:'space-between'
    },
    userInfo:{
        color:theme.HeaderSelectedText,
        fontWeight:"bold"
    }
})

const UserDeletionDialog = (props) => {
    const {classes, userData} = props;
    return (
        <Dialog
        open={true}
        aria-labelledby="UserDeletion-title"
        classes = {{paper: classes.dialog}}
        maxWidth= 'sm'
        >
        <DialogTitle id="UserDeletion-title" classes={{root: classes.dialogTitle}} disableTypography >
            {`Delete User : ${userData.firstName} ${userData.lastName}`}
        </DialogTitle>
        <DialogContent  classes={{root:classes.dialogContent}}>
            <Grid container spacing={24}>
                <Grid item xs={12} classes={{root: classes.message}}>
              {`Are you sure you want to delete the user ${userData.userName} from the ${props.configJSON.terminalAccessLabel.fullName} Access table ?`}
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions classes={{root: classes.dialogAction}}>
            <Grid container spacing={24}>
                <Grid item xs={4}></Grid>
                <Grid item xs={8} classes={{item: classes.actionButton}}>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.button}
                        onClick={props.onCancel}>
                            Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disableRipple
                        className={classes.button}
                        onClick={()=>{
                            props.onConfirm(userData);
                            props.onCancel();
                            }}>
                            Confirm
                    </Button>
                </Grid>
            </Grid>
    </DialogActions>
    </Dialog>
    )
}

export default compose(withStyles(styles), withAppConfig) (UserDeletionDialog);